import React, { useState } from "react";
import { toast } from "react-toastify";
import { get } from "lodash";
import ConfirmationModal from "../../../Common/ConfirmationModal";
import { deleteMlQcRule } from "../../../../actions/qc";

export default function RuleDeleteConfirmation({
  data,
  onConfirm,
  onCancel,
  objKey,
}) {
  const [loading, setLoading] = useState(false);

  const id = get(data, objKey || "rule_id");

  /**
   * handles clicking confirm
   */
  const handleOnConfirm = async () => {
    setLoading(true);
    const response = await deleteMlQcRule(id);
    setLoading(false);
    if (response.success) {
      toast.success(response.message || "Deleted successfully");
      if (onConfirm) onConfirm();
    } else {
      toast.error(response.message || "Something went wrong!");
    }
  };

  return (
    <ConfirmationModal
      open
      title="Delete Rule"
      bodyComponent={() => (
        <div>
          You are about to delete rule
          {" "}
          <strong>{get(data, "rule_type")}</strong>
          {" "}
          with description
          {" "}
          <strong>{get(data, "rule_description")}</strong>
        </div>
      )}
      okText="Delete"
      cancelText="Cancel"
      onOk={handleOnConfirm}
      onCancel={onCancel}
      loading={loading}
    />
  );
}
